module.exports = __webpack_public_path__ + "img/areport.b1b55b28.png";